// Rodzaje motywu kontrolki wyszukiwania
export enum SearchThemeEnum {
    // Normalny tryb
    Normal = 0,
    // Ciemny
    Dark = 1,
    // Light
    Light = 2
}